import React, { useState, useEffect } from 'react';
import SlideUpComponent from '../SlideUp/SlideUpComponent';
import { ExistingCustomerStyles } from './ExistingCustomerStyles';
import Cookies from "js-cookie";
import Router from 'next/router';

const ExistingCustomer = ({
  close,
  hideCloseButton,
  onBack,
  stage,
}) => {
  const [wid, setWid] = useState('');

  useEffect(() => {
    const WID = Cookies.get('SFLeadID',);
    setWid(WID)
  }, []);

  return (
    <SlideUpComponent hideCloseButton={hideCloseButton} active={stage === 'existing-customer'} close={close} onBack={onBack}>
      <ExistingCustomerStyles>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className='title-container'>
                <h3>It looks like you're a current customer.</h3>
                <span>How can we help?</span>
              </div>
              <div className='actions'>
                <div className='action'>
                  <span>I need to speak to my advisor or team</span>
                  <a target="_blank" className='btn btn-secondary btn-block' href="/portal/#/message_center">Portal Login</a>
                </div>
                <div className='action'>
                  <span>I'd like to purchase additional services</span>
                  <a target="_blank" className='btn btn-secondary btn-block' href={"/sfapi/schedule/index.php?WID=" + wid + "&TID=BNA&EmailCampaignID=1800Accountant.com"}>Request Time</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ExistingCustomerStyles>
    </SlideUpComponent>
  );
};

export default ExistingCustomer;
